import * as $ from "jquery";
import CookiesHelper from "../Helpers/helpers.cookies";
import Handlebars from "Handlebars";
import CustomerDetailsComponent from "./components.customerdetails";

export default class CustomersComponent {
    constructor() {
        this.componentSelector = ".customer-search";
        this.instance = this;
        this.debounceTimer = null;
        this.cookies = new CookiesHelper();
        this.customerDetails = new CustomerDetailsComponent();
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
            instance.customerDetails.init();
        }
    }

    bind() {
        let instance = this;
        $('#customer-market').off().on('change', function () {
            instance.cookies.setCookie("country", $('#customer-market').val(), 365);
            instance.search(instance, 1);
        });

        $('#customer-query').off().on('keyup', function () {
            clearTimeout(instance.debounceTimer);
            instance.debounceTimer = setTimeout(function () {
                instance.search(instance, 1);
            }, 850);
        });

        $('#js-customer-update').off().on('click', function () {
            instance.updateCustomer(instance);
        });
        
        var savedMarket = instance.cookies.getCookie("country");
        if (savedMarket != null) {
            $('#customer-market').val(savedMarket);
        }

        $("#headbrands").on('change', function () {
            instance.search(instance, 1);
        });

        $("#mrbarber").on('change', function () {
            instance.search(instance, 1);
        });

        $("#student").on('change', function () {
            instance.search(instance, 1);
        });

        $('#customer-query').focus();
        $('#customer-query').select();
    }

    search(instance, page) {
        let market = $('#customer-market').val();
        let query = $('#customer-query').val();

        let includeHeadbrands = $("#headbrands").prop("checked");
        let includeStudent = $("#student").prop("checked");

        $('tr.customers-show-more').remove();

        if (page == undefined) {
            page = 1;
        }

        axios({
            method: 'post',
            url: "/customer/search",
            data: { market: market, query: query, page: page, includeHeadbrands: includeHeadbrands, includeStudent: includeStudent }
        }).then(function (response) {

            if (page > 1) {
                $('#result').append(response.data);
            }
            else {
                $('#result').html(response.data);
            }

            $('.js-activate-customer').off().on('click', function () {
                var customerNumber = $(this).attr('data-id');
                var marketId = $(this).attr('data-marketid');

                instance.activateCustomer(customerNumber, marketId, instance);
            });

            $('.js-customers-show-more').off().on('click', function () {
                var page = $(this).attr("data-page");
                instance.search(instance, page);
            });

            $('.js-show-customer').off().on('click', function () {
                var customerNumber = $(this).attr('data-id');
                var marketId = $(this).attr('data-marketid');
                instance.customerDetails.getCustomerDetails(customerNumber, marketId, instance.customerDetails);
            });

        }).catch(function (response) {
            console.log(response);
        });
    }

    activateCustomer(customerNumber, marketId, instance) {
        axios({
            method: 'post',
            url: "/customer/activatecustomer",
            data: { customerNumber: customerNumber, marketId: marketId }
        }).then(function (response) {
            window.location.href = "/order";
        }).catch(function (response) {
            console.log(response);
        });
    }
}